import { render, staticRenderFns } from "./Customerprint.vue?vue&type=template&id=551bfcc6&"
import script from "./Customerprint.vue?vue&type=script&lang=js&"
export * from "./Customerprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports